<template>
  <div class="link_content_desc">
    <div class="link_content">
      <div class="link_header">Files</div>
      <div class="link_cont">
        <ButtonWithLoadWebsite class="link_btn">
          <img src="@/assets/img/link_arrow_back.svg" alt="" />
          <div class="link_btn_desc">First</div>
        </ButtonWithLoadWebsite>
        <ButtonWithLoadWebsite class="link_btn">
          <img class="" src="@/assets/img/link_previous.svg" alt="" />
          <div class="link_btn_desc">Previous</div>
        </ButtonWithLoadWebsite>
        <ButtonWithLoadWebsite class="link_btn">
          <img class="link_svg" src="@/assets/img/link_previous.svg" alt="" />
          <div class="link_btn_desc">Next</div>
        </ButtonWithLoadWebsite>
        <ButtonWithLoadWebsite class="link_btn">
          <img class="link_svg" src="@/assets/img/link_arrow_back.svg" alt="" />
          <div class="link_btn_desc">Last</div>
        </ButtonWithLoadWebsite>
        <ButtonWithLoadWebsite class="link_btn_add">
          <svg class="link_icon">
            <use xlink:href="@/assets/img/link_plus.svg#plus"></use>
          </svg>
          <div class="link_addlink">Upload file</div>
        </ButtonWithLoadWebsite>
      </div>
    </div>
    <div>
      <div class="link_training">
        <div class="link_flex link_url_site">
          <div class="link_url">URL</div>
        </div>
        <div class="link_flex link_url_tyle">
          <div class="link_url">Type</div>
        </div>
        <div class="link_flex link_url_tyle">
          <div class="link_url">Status</div>
        </div>
        <div class="link_flex link_url_last">
          <div class="link_url">Uploaded on</div>
        </div>
        <div class="link_flex link_url_last">
          <div class="link_url">Last trained on</div>
        </div>
        <div class="link_settings visibility">
          <div class=""></div>
          <div class="link_settings_desc">
            <div class="link_retrain">Retrain</div>
            <div class="link_delete">Delete</div>
          </div>
        </div>
      </div>
      <div class="link_settings_all">
        <div class="link_url_site link_url__">https://papakava.ua/ua</div>
        <div class="link_url_tyle link_url__">Docx</div>
        <div class="link_url_tyle link_trained">Trained</div>
        <div class="link_url_last link_url__">11.10.2023</div>
        <div class="link_url_last link_url__">8 min ago</div>
        <div class="link_settings">
          <div class=""></div>
          <div class="link_settings_desc">
            <div class="link_retrain">Retrain</div>
            <div class="link_delete">Delete</div>
          </div>
        </div>
      </div>
      <div class="link_settings_all">
        <div class="link_url_site link_url__">https://papakava.ua/ua</div>
        <div class="link_url_tyle link_url__">Doc</div>
        <div class="link_url_tyle link_site_training">
          Training
          <img class="rotate-svg" src="@/assets/img/Loader_link.svg" alt="" />
        </div>
        <div class="link_url_last link_url__"></div>
        <div class="link_url_last link_url__"></div>
        <div class="link_settings">
          <div class=""></div>
          <div class="link_settings_desc">
            <div class="link_retrain"></div>
            <div class="link_delete"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
export default {
  components: {
    ButtonWithLoadWebsite,
  },
};
</script>
<style scoped>
.link_header {
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.link_content {
  max-width: 1000px;
  width: 100%;
  justify-content: space-between;
  display: flex;
}
.link_btn {
  background: none;
  display: flex;
  color: #000;
  text-align: center;
  border-radius: 6px;
  border: 1px solid #c4c4c4;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  align-items: center;
  line-height: 24px;
  justify-content: space-between;
  max-width: 116px;
  width: 100%;
}
.link_btn:hover {
  background: none;
  border: 1px solid #c4c4c4;
}
.link_icon {
  width: 28px;
  height: 28px;
}
.link_training {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 9px 0;
}
.link_url {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.link_cont {
  display: flex;
  gap: 16px;
  width: 100%;
  justify-content: flex-end;
}
.link_delete {
  color: #eb5757;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-decoration-line: underline;
}
.link_url__ {
  color: #828282;
  font-family: "Inter", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.17px;
}
.link_settings_desc {
  display: flex;
  gap: 16px;
}
.link_flex {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.link_trained {
  color: #219653;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.link_btn_desc {
  color: #000;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.link_site_training {
  color: #2f80ed;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.link_btn_add {
  display: flex;
  text-align: center;
  border-radius: 6px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  align-items: center;
  line-height: 24px;
  justify-content: space-between;
  max-width: 116px;
  width: 100%;
}
.link_btn_add:hover .link_icon {
  fill: #3056d3 !important;
}
.link_retrain {
  color: #333;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-decoration-line: underline;
}
.border {
  border: 1px solid #3056d3 !important;
}
.link_addlink {
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.visibility {
  visibility: hidden;
}
.link_settings_all {
  display: flex;
  padding: 9px 0;
  border-bottom: 1px solid #ededed;
  justify-content: space-between;
  width: 100%;
}
.link_url_tyle {
  max-width: 94px;
  width: 100%;
}
.link_url_last {
  max-width: 120px;
  width: 100%;
}
.link_content_desc {
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 900px;
  width: 100%;
}
.link_url_site {
  max-width: 234px;
  width: 100%;
}
.link_settings {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 112px;
  width: 100%;
}
.link_svg {
  transform: rotate(180deg);
}
</style>
